document.addEventListener('click', (e) => {
	const target = e.target;

	if (target.classList.contains('js-field-password__toggle-show')) {
		const parent = target.closest('.js-field-password');
		const inputPassword = parent.querySelector('.js-field-password__input');

		if (inputPassword) {
			const changeToType = inputPassword.getAttribute('type') === 'text' ? 'password' : 'text';

			target.classList.toggle('active');
			inputPassword.setAttribute('type', changeToType);
		}
	}
});
